// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deviceid-input {\n  width: 45em;\n}\n.deviceid-input-small {\n  width: 45em;\n}", ""]);
// Exports
module.exports = exports;
